import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { DecimalPipe } from '@angular/common';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { P_CampaignStageTitle } from '../../shared.pipe';
import { ReplaySubject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { AppService } from '../../../store/app.service';
import { PAGE_NAMES, ROLES } from '../../../core/helpers/constants';
import { TasksService } from '../../../pages/tasks/tasks.service';
import { ITask } from '../../../core/models/tasks.models';
import { IPermission, IUser } from '../../../core/models/auth.models';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TasksApiService } from '../../../pages/tasks/tasks.apiservice';
import { DataFeedService } from '../../api/datafeed.service';
import { DashboardStyleSettingsService, DashboardStyleState } from '../../services/dashboard-style-settings.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-tasks-dashboard',
  templateUrl: './tasks-dashboard.component.html',
  styleUrls: ['./tasks-dashboard.component.scss'],
  providers: [DecimalPipe, P_CampaignStageTitle]
})

export class TasksDashboardComponent implements OnInit, OnDestroy {
  private dashboardInitialized = false;
  private _savedSearchId: string | null = null;

  @Input()
  set iSavedSearchId(value: string | null) {
    this._savedSearchId = value || null;
    if (this.dashboardInitialized) {
      this.loadTaskData();
    }
  }

  get iSavedSearchId(): string | null {
    return this._savedSearchId;
  }
  private readonly legacyDefaultCardBgColor = '#ffffff';
  private readonly legacyDefaultCardBgOpacityPct = 100;
  private readonly legacyDefaultTaskColumnBgColor = '#d3d3d3';
  private readonly legacyDefaultTaskColumnBgOpacityPct = 100;
  private readonly legacyDefaultTaskHeaderColor = '#495057';

  backgroundImageStyle: SafeStyle | null = null;

  bgImageOpacityPct = 100;

  cardBgColor = '#ffffff';
  cardBgOpacityPct = 100;

  taskcolBgColor = '#d3d3d3';
  taskcolBgOpacityPct = 100;

  taskHeaderColor = '#495057';

  doWhat: IPermission = {} as IPermission;
  // activeUser: IUser = {} as IUser;
  allUsers: Array<IUser> = new Array<IUser>();
  ROLES = ROLES;

  searchString = '';
  // dataTotalCount: number = 0;
  myTasks: boolean = true;

  automationsList: Array<{ id: number, name: string, client: string, tasks: any }> = [];

  constructor(
    private appService: AppService,
    private dataFeedService: DataFeedService,
    private tasksService: TasksService,
    private tasksApi: TasksApiService,
    private sanitizer: DomSanitizer,
    private dashboardStyleSettingsService: DashboardStyleSettingsService,
    private translate: TranslateService,
  ) {
    this.tasksData = new Array<ITask>();
    this.thisWeekTasksData = new Array<ITask>();
    this.overdueTasksData = new Array<ITask>();
    this.futureTasksData = new Array<ITask>();

    this.automationsList = [
      { id: 1, name: this.translate.instant('NEW_CAMPAIGN_SETUP'), client: '', tasks: [
      "Assign DMS",
      "Schedule New Campaign Onboarding Call",
      "Tech Setup",
      "Campaign Setup",
      "Ad Approval",
      "Setup QC",
      "Start Campaign"
    ] },
      { id: 2, name: this.translate.instant('NEW_CORPORATE_OFFER'), client: 'Corporate', tasks: [
      "Verify Offer Details",
      "Upload/Create New Offer Assets",
      "Share Offer Details with your DMSes",
      "New Offer Copy",
      "Review New Ad Copy and Creaive",
      "Create/Get LP for New Offer",
      "Get Corporate Approval on New Offer Copy",
      "Add New Copy to Brands Sheet",
      "Create Ads for New Corporate Offer"
    ] },
      { id: 3, name: this.translate.instant('NEW_BRAND_ONBOARDING'), client: 'Corporate', tasks: [
      "Collect All Needed Assets From the Brand",
      "Kickoff Call Completed",
      "Setup CRM Integration",
      "LP Site",
      "Prepare REACH for the New Brand",
      "Upload Assets to FFM Drive",
      "Choose Top Assets",
      "Organize Assets",
      "Campaign Strategy for the Brand",
      "Create Keywords",
      "Create the Copy",
      "Review the Ad Copy",
      "Review the Copy",
      "Build Ad Previews & Create Copy Docs",
      "Design the Landing Page Templates",
      "Build the Landing Pages",
      "Review All Creative",
      "Create Preview Deck",
      "Review the Preview Deck",
      "Brand Strategy Approval",
      "Brand Approval",
      "Organize Brand Assets",
      "QC Familiarization with New Brand",
      "New Brand",
      "Set Up Subscription",
      "Check if the first campaign is live"
      ] }
    ];

    this.dataFeedService.getAllTaskAssignees()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((response: any) => {
        if (response.good) {
          this.allUsers = [...response.data].map((i) => { i.fullName = i.firstName + ' ' + i.lastName; return i; });
          const activeUser: any = this.appService.getActiveUser$().value;
          const activeUserId = String(activeUser?.id ?? '').trim();
          if (activeUserId && this.allUsers.some(user => String(user?.id ?? '').trim() === activeUserId)) {
            this.selectedUserId = activeUserId;
            this.myTasks = true;
            this.loadTaskData();
          }
          // console.log(this.allUsers);
        }
      });
  }

  tasksData: Array<ITask>;
  thisWeekTasksData: Array<ITask>;
  overdueTasksData: Array<ITask>;
  futureTasksData: Array<ITask>;

  selectedUserId: string | null = null;
  selectedAutomationId: number | null = null;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  showNextWeek: boolean = false;

  readonly weekDays: Array<{ key: string; dayIndex: number }> = [
    { key: 'MONDAY', dayIndex: 1 },
    { key: 'TUESDAY', dayIndex: 2 },
    { key: 'WEDNESDAY', dayIndex: 3 },
    { key: 'THURSDAY', dayIndex: 4 },
    { key: 'FRIDAY', dayIndex: 5 },
  ];
  
  ngOnInit(): void {
    this.dashboardStyleSettingsService.watch('tasks')
      .pipe(takeUntil(this.destroyed$))
      .subscribe((state) => this.applySharedStyleState(state));
    /*
    this.appService.getActiveUser$()
      .subscribe(u => {
          this.activeUser = u;
      });
    */
    this.doWhat = this.appService.getUserRolesForPage(PAGE_NAMES.Tasks);
    this.dashboardInitialized = true;
    this.loadTaskData();
  }
  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  get cardBgRgba(): string {
    return this.hexToRgba(this.cardBgColor, this.cardBgOpacityPct / 100);
  }

  get taskcolBgRgba(): string {
    return this.hexToRgba(this.taskcolBgColor, this.taskcolBgOpacityPct / 100);
  }

  get usesThemeDefaults(): boolean {
    return this.backgroundImageStyle == null
      && this.normalizeHex(this.cardBgColor) === this.legacyDefaultCardBgColor
      && this.cardBgOpacityPct === this.legacyDefaultCardBgOpacityPct
      && this.normalizeHex(this.taskcolBgColor) === this.legacyDefaultTaskColumnBgColor
      && this.taskcolBgOpacityPct === this.legacyDefaultTaskColumnBgOpacityPct
      && this.normalizeHex(this.taskHeaderColor) === this.legacyDefaultTaskHeaderColor;
  }

  get dashboardCardBackground(): string | null {
    return this.usesThemeDefaults ? null : this.cardBgRgba;
  }

  get dashboardColumnBackground(): string | null {
    return this.usesThemeDefaults ? null : this.taskcolBgRgba;
  }

  get dashboardHeaderColor(): string | null {
    return this.usesThemeDefaults ? null : this.taskHeaderColor;
  }

  private clamp01(value: number): number {
    if (!Number.isFinite(value)) return 1;
    return Math.min(1, Math.max(0, value));
  }

  private normalizeHex(value: string | null | undefined): string {
    const normalized = (value ?? '').toString().trim().toLowerCase();
    if (!normalized) {
      return '';
    }

    return normalized.startsWith('#') ? normalized : `#${normalized}`;
  }

  private hexToRgba(hex: string, alpha: number): string {
    const normalized = (hex ?? '').toString().trim();
    const match = /^#?([0-9a-f]{6})$/i.exec(normalized);
    if (!match) {
      return `rgba(255,255,255,${this.clamp01(alpha)})`;
    }

    const intVal = parseInt(match[1], 16);
    const r = (intVal >> 16) & 255;
    const g = (intVal >> 8) & 255;
    const b = intVal & 255;
    return `rgba(${r},${g},${b},${this.clamp01(alpha)})`;
  }

  private applySharedStyleState(state: DashboardStyleState): void {
    this.bgImageOpacityPct = state.bgImageOpacityPct;
    this.cardBgColor = state.cardBgColor;
    this.cardBgOpacityPct = state.cardBgOpacityPct;
    this.taskcolBgColor = state.taskcolBgColor;
    this.taskcolBgOpacityPct = state.taskcolBgOpacityPct;
    this.taskHeaderColor = state.taskHeaderColor;
    this.backgroundImageStyle = state.backgroundImageUrl
      ? this.sanitizer.bypassSecurityTrustStyle(`url("${state.backgroundImageUrl}")`)
      : null;
  }

  isTaskDueOnDay(dueDate: string, dayIndex: number): boolean {
    const date = new Date(dueDate);
    return date.getDay() === dayIndex;
  }

  getTaskCountForDay(dayIndex: number): number {
    return this.thisWeekTasksData.filter(task => this.isTaskDueOnDay(task.dueDate, dayIndex)).length;
  }

  isOverdue(dueDate: string): boolean {
    const today = new Date();
    const taskDueDate = new Date(dueDate);

    // Reset time to 00:00:00 for accurate comparison
    today.setHours(0, 0, 0, 0);
    taskDueDate.setHours(0, 0, 0, 0);

    return taskDueDate < today;
  }

  loadTaskData(search: string | null = null): void {
    this.tasksData = [];
    const searchValue = search ? search : this.searchString;
    const activeUser: any = this.appService.getActiveUser$().value;
    const activeUserId = String(activeUser?.id ?? '').trim();
    const selectedUserId = String(this.selectedUserId ?? '').trim();
    const showOnlyMyTasks = !!activeUserId && selectedUserId === activeUserId;

    this.tasksApi.getAllTasks({ savedSearchId: this.iSavedSearchId, search: searchValue, showOnlyMyTasks, completion: 1 })
    .pipe(takeUntil(this.destroyed$))
    .subscribe((response: any) => {
      // console.log('tasks data: ', response);
      if (this.selectedAutomationId !== null) {
        const automation = this.automationsList.find(a => a.id === this.selectedAutomationId);
        if (automation) {
          this.tasksData = this.sortTasksForDashboard(response.data.filter((task: ITask) => 
            (!this.selectedUserId || task.assignedUserId === this.selectedUserId) &&
            automation.tasks.some((automationTask: string) => task.title.includes(automationTask)) &&
            (!automation.client || (task.clientName && task.clientName.includes(automation.client)))
          ));
        }
      } else if (this.selectedUserId !== null) {
        this.tasksData = this.sortTasksForDashboard(
          response.data.filter((task: ITask) => task.assignedUserId === this.selectedUserId)
        );
      } else {
        this.tasksData = this.sortTasksForDashboard(response.data);
      }
      // this.dataTotalCount = response.totalCount;
      this.groupTasksData();
      // console.log('this week: ', this.thisWeekTasksData);
      // console.log('overdue: ', this.overdueTasksData);
      // console.log('future: ', this.futureTasksData);
    });
  }

  private sortTasksForDashboard(tasks: ITask[]): ITask[] {
    return [...(tasks ?? [])].sort((a: ITask, b: ITask) => {
      const titleCompare = this.compareText(a?.title, b?.title);
      if (titleCompare !== 0) return titleCompare;

      const clientCompare = this.compareText(a?.clientName, b?.clientName);
      if (clientCompare !== 0) return clientCompare;

      const campaignCompare = this.compareText(a?.campaignName, b?.campaignName);
      if (campaignCompare !== 0) return campaignCompare;

      return this.compareText((a as any)?.id, (b as any)?.id);
    });
  }

  private compareText(left: any, right: any): number {
    return String(left ?? '').trim().localeCompare(String(right ?? '').trim(), undefined, {
      sensitivity: 'base',
      numeric: true,
    });
  }

  toggleWeekView() {
    this.showNextWeek = !this.showNextWeek;
    this.groupTasksData();
  }

  groupTasksData() {
    const today = new Date();
    const dayOfWeek = today.getDay();
    let monday = new Date(today);
    let friday = new Date(today);

    if (this.showNextWeek) {
      // Move to next week's Monday
      const daysUntilNextMonday = ((8 - dayOfWeek) % 7) || 7;
      monday.setDate(today.getDate() + daysUntilNextMonday);
      friday = new Date(monday);
      friday.setDate(monday.getDate() + 4);
    } else {
      // This week
      monday.setDate(today.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1));
      friday = new Date(monday);
      friday.setDate(monday.getDate() + 4);
    }

    // Reset time to 00:00:00 for accurate comparison
    monday.setHours(0, 0, 0, 0);
    friday.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    this.thisWeekTasksData = [];
    this.overdueTasksData = [];
    this.futureTasksData = [];
    
    this.tasksData.forEach(task => {
      const dueDate = new Date(task.dueDate);
      dueDate.setHours(0, 0, 0, 0); // Reset time to 00:00:00 for accurate comparison
      if (!this.showNextWeek) {
        if (dueDate < monday) {
          this.overdueTasksData.push(task);
        } else if (dueDate >= monday && dueDate <= friday) {
          this.thisWeekTasksData.push(task);
        } else if (dueDate > friday) {
          this.futureTasksData.push(task);
        }
      } else {
        // Next week
        if (dueDate < monday) {
          this.overdueTasksData.push(task);
        } else if (dueDate >= monday && dueDate <= friday) {
          this.thisWeekTasksData.push(task);
        } else if (dueDate > friday) {
          this.futureTasksData.push(task);
        }
      }
    });
  }

  onAddTaskClick(action: any) {
    const modalRef: NgbModalRef = this.tasksService.openEditTaskModal({ id: action === 'add' ? null : -1 }, true, true);
    modalRef.componentInstance.oSaveClicked.pipe(
      takeUntil(this.destroyed$),
      debounceTime(500)
    ).subscribe(() => {
      this.loadTaskData();
    });
  }

  viewTask(evt: any) {
    const modalRef: NgbModalRef = this.tasksService.openEditTaskModal(evt);
    modalRef.componentInstance.oSaveClicked.pipe(
      takeUntil(this.destroyed$),
      debounceTime(500)
    ).subscribe(() => {
      this.loadTaskData();
    });
    modalRef.componentInstance.oDeleteClicked.pipe(
      takeUntil(this.destroyed$),
      debounceTime(500)
    ).subscribe(() => {
      this.loadTaskData();
    });
    modalRef.componentInstance.oMarkAsCompleteClicked.pipe(
      takeUntil(this.destroyed$),
      debounceTime(500)
    ).subscribe(() => {
      this.loadTaskData();
    });
  }

  doSearch(event: any) {
    this.searchString = event.target.value;
    this.loadTaskData();
  }

  filterByUser(userId: string | null): void {
    // this.selectedAutomationId = null;
    const selectedUser = this.allUsers.find(user => user.id === userId);
    if (selectedUser) {
      const activeUser: any = this.appService.getActiveUser$().value;
      const activeUserId = String(activeUser?.id ?? '').trim();
      this.myTasks = String(selectedUser.id ?? '').trim() === activeUserId;
      if (this.searchString === '') {
        let search = selectedUser.lastName ? selectedUser.lastName.split(/[^a-zA-Z]/)[0] : '';
        this.loadTaskData(search);
      } else {
        this.loadTaskData();
      }
    } else {
      this.myTasks = false;
      this.loadTaskData();
    }
  }

  filterByAutomation(automationId: number | null): void {
    // this.selectedAutomationId = automationId;
    // this.selectedUserId = null;
    this.loadTaskData();
  }
 
}
